module.exports = __webpack_public_path__ + "static/img/14o.5ee5ee3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/14o.jpg
// module id = L6R2
// module chunks = 0